import React from "react";

const CampaignStatusBadge = ({ campaignStatus, styles }) => {
  let badgeColor = "";
  if (campaignStatus === "live") {
    badgeColor = "#21BDCA";
  } else if (campaignStatus === "ended") {
    badgeColor = "#495057";
  } else {
    badgeColor = "#FA4764";
  }

  return (
    <div
      className="badge p-2 ml-md-3 mb-md-3"
      style={{
        backgroundColor: badgeColor,
        color: "#FFFFFF",
        fontSize: "12px",
        ...styles,
      }}
    >
      {campaignStatus.toUpperCase()}
    </div>
  );
};

export default CampaignStatusBadge;
